import ReadSentenceShort from "./bookItems/sound/read_sentence_short";
import PlaySound from "./bookItems/sound/play_sound";
import PlaySoundComplete from "./bookItems/sound/play_sound_complete";
import ReadSentenceTurnPage from "./bookItems/sound/read_sentence_turn_page";
import ReadSentence from "./bookItems/sound/read_sentence";
import Sentence from "./bookItems/sound/sentence";
import SentenceGroup from "./bookItems/sound/sentence_group";
import SentenceFollowGroup from "./bookItems/sound/sentence_follow_group";
import AfilePageCount from "./bookItems/afile/afile_page_count";
import OpenAfile from "./bookItems/afile/open_afile";
import AfileChangeImg from "./bookItems/afile/afile_change_img";
import AfileChangePage from "./bookItems/afile/afile_change_page";
import AfileChangePageNew from "./bookItems/afile/afile_change_page_new";
import AfileVideo from "./bookItems/afile/afile_video";

import AfileChangeBGPic from "./bookItems/afile/afile_change_bg_pic";
import AfileChangeBGPicStep from "./bookItems/afile/afile_change_bg_pic_step";

import VisibleSwitchList from "./bookItems/visibleswitchlist/visible_switch_list";
import VisibleSwitchListChild from "./bookItems/visibleswitchlist/visible_switch_list_child";
import VisibleSwitchAns from "./bookItems/visibleswitchans/visible_switch_ans";
import VisibleSwitchAnsChild from "./bookItems/visibleswitchans/visible_switch_ans_child";
import VisibleSwitchAnsStepAllGroup from "./bookItems/visibleswitchans_step/visible_switch_ans_step_all_group";
import VisibleSwitchAnsStepAllGroupChild from "./bookItems/visibleswitchans_step/visible_switch_ans_step_all_group_child";
import VisibleSwitchAnsStepAll from "./bookItems/visibleswitchans_step/visible_switch_ans_step_all";
import VisibleSwitchAnsStep from "./bookItems/visibleswitchans_step/visible_switch_ans_step";
import VisibleSwitchAnsStepChild from "./bookItems/visibleswitchans_step/visible_switch_ans_step_child";
import VisibleSwitchAnsStepPicChild from "./bookItems/visibleswitchans_step/visible_switch_ans_step_pic_child";
import VisibleSwitchLine from "./bookItems/visibleswitchansline/visible_switch_line";
import VisibleSwitchLineChild from "./bookItems/visibleswitchansline/visible_switch_line_child";
import VisibleSwitchTranslate from "./bookItems/visibleswitchtranslate/visible_switch_translate";
import VisibleSwitchTranslateChild from "./bookItems/visibleswitchtranslate/visible_switch_translate_child";
import JumpPage from "./bookItems/jumppage/jump_page";
import MutualSoundAfile from './bookItems/mutualsoundAfile/mutual_sound_Afile'
import MutualSoundAfileGroupChild from './bookItems/mutualsoundAfile/mutual_sound_Afile_group_child'
import MapToggle from './bookItems/maptoggle/map_toggle'
import MapToggleSwitchChild from './bookItems/maptoggle/map_toggle_switch_child'
import MapToggleChild from './bookItems/maptoggle/map_toggle_child'
import Sticker from './bookItems/sticker/sticker'
import StickerOpen from './bookItems/sticker/sticker_open'
import StickerReset from './bookItems/sticker/sticker_reset'
import OutOpen from "./bookItems/outopen/outopen"
import OutOpenHtml from "./bookItems/outopen/outopen_html"
import ControlAniState from "./bookItems/controlanistate/control_ani_state"
import ControlAniStatePic from "./bookItems/controlanistate/control_ani_state_pic"
import Debugger from "./console/debugger";
import ReadMultipleSentence from "./bookItems/sound/read_multiple_sentence";

const BookItemClass = {
    //開關
    "grouptrigger": VisibleSwitchList,
    "grouptrigger_child": VisibleSwitchListChild,

    "ansshowbtn": VisibleSwitchAns,
    "ansshowbtnchild": VisibleSwitchAnsChild,

    "stepallbtn": VisibleSwitchAnsStepAll,
    "visibleSwitchAnsStepAllGroup": VisibleSwitchAnsStepAllGroup,
    "visibleSwitchAnsStepAllGroupChild": VisibleSwitchAnsStepAllGroupChild,
    "stepbtn": VisibleSwitchAnsStep,
    "stepbtnchild": VisibleSwitchAnsStepChild,
    "stepbtnpicchild": VisibleSwitchAnsStepPicChild,

    "lineshowbtn": VisibleSwitchLine,
    "lineshowbtnchild": VisibleSwitchLineChild,

    "translate": VisibleSwitchTranslate,
    "translatechild": VisibleSwitchTranslateChild,

    "mutualsoundAfile": MutualSoundAfile,
    "mutualsoundAfilegroupchild": MutualSoundAfileGroupChild,
    //跳頁
    "jumppagebtn": JumpPage,

    // 音檔
    "playSound": PlaySound,
    "playSoundComplete": PlaySoundComplete,
    "readSentence": ReadSentence,
    "sentence": Sentence,
    "sentenceGroup": SentenceGroup,
    "sentenceFollowGroup": SentenceFollowGroup,
    "readSentenceShort": ReadSentenceShort,
    "readSentenceTurnPage": ReadSentenceTurnPage,
    "readMultipleSound": ReadMultipleSentence,
    // A檔
    "openAfile": OpenAfile,
    "afileChangePage": AfileChangePage,
    "afileVideo": AfileVideo,
    "afileChangeImg": AfileChangeImg,
    "afilePageCount": AfilePageCount,
    "maptoggle": MapToggle,
    "maptoggleswitchchild": MapToggleSwitchChild,
    "maptogglechild": MapToggleChild,

    "afilechangebgpic": AfileChangeBGPic,
    "afilechangebgpicstep": AfileChangeBGPicStep,

    "sticker": Sticker,
    "stickeropen": StickerOpen,
    "stickerreset": StickerReset,

    "controlAniState": ControlAniState,
    "controlAniStatePic": ControlAniStatePic,

    //外開
    "outopen": OutOpen,
    "outopen_html": OutOpenHtml,

    //test
    "afileChangePageNew": AfileChangePageNew

}
export default class PageItemControl {
    bookItems = [];
    bookItems_temp = [];
    movieClips = new Map();
    parents_temp = [];
    isInit = false;
    loader = null; //配合用來載入animator內容的loader

    totalBookItem = -1;
    childItemCount = 0;
    isExportRootExit = false;

    classGroups = {};

    //渲染完畢後要執行的callBack
    initCallBack = null;
    pageIds = []

    timer = null;
    /**
     * 初始化用的Timer
     * @type {Number}
     * @memberof PageItemControl
     */
    initTimer = null;

    /**
     * init book items time in ms
     * @type {Number}
     * @memberof PageItemControl
     */
    countdownTime = 200;


    constructor(loader) {
        this.loader = loader;
        this.loader.itemControl = this;
        // Debugger.Instance.showLog();
    }

    clearItems() {
        window.currentPageItemControl = this;
        this.isExportRootExit = false;
        this.totalBookItem = -1;
        this.childItemCount = 0;
        this.bookItems = [];
        this.bookItems_temp = [];
        this.parents_temp = [];
        this.isInit = false;
        this.classGroups = {};
        this.movieClips.clear();
    }

    initBookItems() {
        const self = this;
        this.setNewPageId();

        const stage = this.loader.pageStage;

        for (let i = 0; i < this.bookItems.length; i++) {
            const pageIndex = this.getPageIndex(this.bookItems[i].target);

            if (pageIndex > -1) {
                this.bookItems[i].pageId = stage.children[pageIndex].id;
            }
        }
        if (this.timer) {
            clearTimeout(this.timer);
        }

        let rootChildren = [].concat.apply([], this.loader.pageContainers.map(pageContainer => pageContainer.exportRoot.children));;

        this.bookItems.sort((a, b) => {
            return rootChildren.indexOf(b.target) - rootChildren.indexOf(a.target);
        })

        this.timer = setTimeout(() => {
            self.loader.mutiAntialiasing();
            if (self.initCallBack) {
                self.initCallBack();
                self.initCallBack = null;
            }

            for (let i = 0; i < this.bookItems.length; i++) {
                this.bookItems[i].start();
            }

            self.loader.renderBook();
        });
    }
    pushBookItem(child, parent) {
        parent.stop();

        // TODO: 這邊parent.parent有可能會沒有，這邊先擋掉。
        if (parent.parent) {
            this.initBookItem(child, parent);

            this.countdownInitBookItems();
        }
    }

    countdownInitBookItems() {
        if (!this.isInit) {
            const self = this;
            clearTimeout(this.initTimer);
            this.initTimer = setTimeout(() => {
                if (this.checkExportRootExit()) {
                    self.isInit = true;
                    self.initBookItems();
                }
            }, this.countdownTime);
        }
    }

    initBookItem(bookItem, parent) {
        if (!bookItem) {
            return;
        }
        if (!this.movieClips.has(bookItem.id)) {
            this.movieClips.set(bookItem.id, bookItem);
        } else {
            return;
        }

        let bookItemComponent = new BookItemClass[bookItem.name](bookItem._element._options, parent);

        const id = this.bookItems.push(bookItemComponent);
        bookItemComponent.id = id;

        const className = BookItemClass[bookItem.name].name;
        if (this.classGroups[className] == null) {
            this.classGroups[className] = [];
        }

        this.classGroups[className].push(bookItemComponent);

        bookItemComponent.itemControl = this;

        setTimeout(() => {
            bookItemComponent.init();
            bookItemComponent.initLate();
        });

    }


    /**
     * 確認bookItem的父層是不是頁面
     *
     * @memberof PageItemControl
     */
    checkItemParent(item) {
        let result = false;
        if (item.parent == null) {
            return result;
        }

        for (let i = 0; i < this.loader.pageContainers.length; i++) {
            if (this.loader.pageContainers[i].exportRoot) {
                if (this.loader.pageContainers[i].exportRoot.id == item.parent.id) {
                    result = true;
                    continue;
                }
            }
        }

        return result;
    }

    checkItemParentId(item) {
        for (let i = 0; i < this.loader.pageContainers.length; i++) {
            if (this.loader.pageContainers[i].exportRoot) {
                if (this.loader.pageContainers[i].exportRoot.children.includes(item)) {
                    console.log(item, "page id", this.loader.pageContainers[i].exportRoot.id);
                    return this.loader.pageContainers[i].exportRoot.id;
                }
            }
        }
        console.log("not page");
        return null
    }

    checkExportRootExit() {
        let exit = true;
        if (!this.isExportRootExit) {
            let i = 0;
            for (i = 0; i < this.loader.pageContainers.length; i++) {
                if (this.loader.pageContainers[i].exportRoot == null) {
                    exit = false;
                }
            }
            if (exit) {
                this.isExportRootExit = true;
            }
            return this.isExportRootExit;
        } else {
            return this.isExportRootExit;
        }
    }

    reInitStage() {
        const self = this;
        let stage = this.loader.pageContainers[0].exportRoot;
        let i = 0;
        setTimeout(() => {
            // self.clearItems();
            for (i = 0; i < stage.numChildren; i++) {
                stage.children[i].isSingleFrame = false;
                stage.children[i].frame_0();
            }
        });
    }

    checkIDRepeat(id) {
        let i = 0;
        for (i = 0; i < this.bookItems_temp.length; i++) {
            if (this.bookItems_temp[i].id == id) {
                Debugger.Instance.log({ "repeat": this.bookItems_temp[i] }, "pageItem_control");
                return true;
            }
        }

        return false;
    }

    getItemsByClassName(className, obj) {
        let classNameNew = BookItemClass[className].name;
        if (this.classGroups[classNameNew] == undefined) {
            console.log(obj, ": ClassName:", classNameNew, "is undefined");
        }
        return this.classGroups[classNameNew] || [];
    }

    getItemsByClassConnect(className, obj) {
        let tempFilterGroup = [];
        if (className != "") {
            tempFilterGroup = this.getItemsByClassName(className, obj);
        }

        if (tempFilterGroup != undefined) {
            tempFilterGroup = tempFilterGroup.filter(child => {
                return child.connectNumber == obj.connectNumber;
            })
        }

        return tempFilterGroup;
    }

    getItemsByClassGroupConnect(className, obj) {
        let tempFilterGroup = [];
        if (className != "") {
            tempFilterGroup = this.getItemsByClassName(className, obj);
        }

        if (tempFilterGroup != undefined) {
            tempFilterGroup = tempFilterGroup.filter(child => {
                return child.connectNumber.includes(obj.connectNumber);
            })
        }

        return tempFilterGroup;
    }

    getItemsByClassConnectWithPageId(className, obj) {
        let tempFilterGroup = [];
        if (className != "") {
            tempFilterGroup = this.getItemsByClassName(className, obj);
        }

        if (tempFilterGroup != undefined) {
            tempFilterGroup = tempFilterGroup.filter(child => {
                return child.connectNumber == obj.connectNumber;
            })
        }

        if (tempFilterGroup != undefined) {
            tempFilterGroup = tempFilterGroup.filter(child => {
                return child.pageId == obj.pageId;
            })
        }
        console.log("tempFilterGroup", tempFilterGroup);
        return tempFilterGroup;
    }

    getItemsByClassPageId(className, obj) {
        console.log("pageId:", obj.pageId);
        let tempFilterGroup = [];
        if (className != "") {
            tempFilterGroup = this.getItemsByClassName(className, obj);
        }

        if (tempFilterGroup != undefined) {
            tempFilterGroup = tempFilterGroup.filter(child => {
                return child.pageId == obj.pageId;
            })
        }
        // console.log("getItemsByClassPageId",tempFilterGroup);
        return tempFilterGroup;
    }

    setNewPageId() {
        let stage = this.loader.pageStage;
        this.pageIds = [];
        let i = 0;
        for (i = 0; i < stage.numChildren; i++) {
            this.pageIds.push(stage.children[i].id);
        }
    }

    getPageIndex(obj) {
        if (obj) {
            const stage = this.loader.pageStage;
            let pageIndex = stage.children.indexOf(obj.parent);

            if (pageIndex == -1) {
                pageIndex = this.getPageIndex(obj.parent);
            }

            return pageIndex;
        } else {
            return -1;
        }
    }
}